export var attTheme = {
    colors: {
        primary: "#009FDB",
        primaryDark: "#0057B8",
        secondary: "#007AE2",
        purple: "#AF29BB",
        pink: "#FF585D",
        pinkDark: "#FF4349",
        orangeLight: "#FFB000",
        orange: "#FF8500",
        orangeDark: "#D36C00",
        greenLight: "#91DC00",
        green: "#3DA930",
        greenDark: "#2D7E24",
        teal: "#49EEDC",
        black: "#000",
        greyDarker: "#1D2329",
        greyDark: "#3F3F3F",
        grey: "#949599",
        greyLight: "#BFBFBF",
        greyLighter: "#E7E7E8",
        white: "#FFF",
    },
    gradients: {
        blue: "linear-gradient(90deg, #0079B1 0%, #009FDB 50.52%, #00C9FF 100%)",
        blueDark: "linear-gradient(90deg, #096FEC 0%, #1081FC 100%)",
        bluePurple: "linear-gradient(90deg, #0057B8 0%, #AF29BB 100%)",
        orange: "linear-gradient(90deg, #FF585D 0%, #FFB000 100%)",
        green: "linear-gradient(90deg, #91DC00 0%, #49EEDC 100%)",
    },
    typography: {
        bodyColor: "#000",
        fontFamily: "'ATT Aleck Sans', 'neue-haas-grotesk-display', sans-serif",
        fontSize: "100%",
        title: {
            fontSize: 75,
            fontSizeTablet: 75,
            fontSizeMobile: 48,
            lineHeight: "1.05",
            fontWeight: "bold",
        },
        heading2: {
            fontSize: 60,
            fontSizeTablet: 48,
            fontSizeMobile: 40,
            lineHeight: "1.05",
            fontWeight: "bold",
        },
        heading3: {
            fontSize: 40,
            fontSizeTablet: 24,
            fontSizeMobile: 24,
            lineHeight: "1.15",
            fontWeight: "bold",
        },
        heading4: {
            fontSize: 32,
            fontSizeTablet: 24,
            fontSizeMobile: 24,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading5: {
            fontSize: 32,
            fontSizeTablet: 32,
            fontSizeMobile: 32,
            lineHeight: "1.2",
            fontWeight: "normal",
        },
        heading6: {
            fontSize: 24,
            fontSizeTablet: 24,
            fontSizeMobile: 24,
            lineHeight: "1.35",
            fontWeight: "normal",
        },
        body: {
            fontSize: 16,
            fontSizeMobile: 16,
            fontSizeTablet: 16,
            lineHeight: "1.5",
            fontWeight: "normal",
        },
    },
};
